import React, { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import ApiService from '../../services/apiService';
import { RxCross1 } from "react-icons/rx";
const StockAdjViewGrid = ({ itemData, currencyPrecision }) => {
    const [itemRows, setItemRows] = useState([]);
    const apiService = new ApiService();

    useEffect(() => {
        const fetchData = async () => {
            try {
                 
                const formattedRowsPromises = itemData?.adjDetails.map(async (detail, index) => {
                    const queryParam = `itemNo=${detail.itemCode}`;
                    const selecteditmstock = await apiService.getApiParamater('GET_ITEM_STORE', `?Warehouse=${itemData?.label}&${queryParam}`);
                     
                    let item = selecteditmstock?.data?.result[0]
                    return {
                        srno: detail.srno,
                        itemNo: detail.itemCode,
                        recordId: detail.itemCode,
                        itemDescription: detail.itemDescription,
                        branch: '',
                        qty: detail.qty,
                        uom: detail.uom,
                        baseQty: 0,
                        convRate: detail.baseQty,
                        baseAmount: detail.unitPrice,
                        specification: detail.specification,
                        amount: detail.amount,
                        stock: item.stock,
                        remarks: detail.remarks
                    };
                }).filter(row => row !== null);
                const formattedRows = await Promise.all(formattedRowsPromises);
                if (formattedRows.length > 0) {
                    setItemRows(formattedRows);
                }
            } catch (error) {
                console.error('Error handling input change:', error);
            }
        };
        if (itemData) {
            fetchData();
        }
    }, [itemData]);
    return (
        <div className='table-container p-2 mb-5' style={{ overflowX: 'auto', height: "400px" }}>
            <table>
                <thead className='dynoTable'>
                    <tr>
                        <th></th>
                        <th>Sr no</th>
                        <th>Item No</th>
                        <th>Description</th>
                        <th>Item Specs</th>
                        <th>Inventory Qty</th>
                        <th>Inventory UOM</th>
                        <th>Unit Price</th>
                        <th>Amount</th>
                        <th>Stock</th>
                        <th>Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(itemRows) && itemRows?.map((row, index) => (
                        <tr key={index}>
                            <td className='m-0 p-0' style={{ border: "1px solid rgba(118, 118, 118, 0.3)", cursor: "not-allowed" }}>
                                <div className='center'>
                                    <RxCross1 size={25} disabled />
                                </div>
                            </td>
                            <td className='m-0 p-0'><input className='p-2' disabled style={{ width: "80px" }} value={row.srno} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={row?.itemNo} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={row.itemDescription} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={row.specification} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={row.qty} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={row.uom} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.baseAmount).toFixed(currencyPrecision || 0)} style={{ width: "130px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={Number(row.amount).toFixed(currencyPrecision || 0)} style={{ width: "120px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={row.stock} style={{ width: "100px" }} /></td>
                            <td className='m-0 p-0'><input className='p-2' disabled value={row.remarks} style={{ width: "130px" }} /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default StockAdjViewGrid;